import { User } from '@mews-commander/data-access';
import { PreferencesFormProps, PreferencesFormValues } from './PreferencesForm/types';

const mapUserToPreferencesFormValues = (user: User): PreferencesFormValues => ({
    preferredLanguageCode: user.preferredLanguageCode || null,
    preferredCultureCode: user.preferredCultureCode || null,
    defaultProfileId: user.profiles?.find((p) => p.isDefault)?.profileId || null,
});

export const useMapUserToPreferencesFormProps = (user?: User): PreferencesFormProps => {
    if (!user) {
        return {} as PreferencesFormProps;
    }

    return {
        defaultValues: mapUserToPreferencesFormValues(user),
        profiles: user.profiles || [],
    };
};
